import {
    Inject,
    ISimpleControllerConfiguration,
    ResourceItem,
    SimpleBaseController,
} from '@denishussar/html5-game-engine';

import * as PIXI from 'pixi.js';
import 'pixi-spine';

export interface ISpineControllerOptions {
    key: string;
    url: string;
    animations: string[];
}

export class SpineAnimationBaseController extends SimpleBaseController {
    $model: any;

    protected _spineData: PIXI.spine.core.SkeletonData;
    protected _spine: PIXI.spine.Spine;
    protected currentTrack;

    public currAnimation: string = '';

    public constructor(@Inject private _options: ISpineControllerOptions) {
        super('SpineAnimationBaseController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        this._options.key = this._options.key + Math.random().toString();

        const key = this._options.key;
        const url = this._options.url;

        const resources = {};

        console.log(this.resourcesLoader.loader.resources);

        if (!(key in this.resourcesLoader.loader.resources)) {
            resources[key] = new ResourceItem(key, url);
        }
        // resources[key] = new ResourceItem(key, url);

        return {
            resources: resources,
        };
    }

    protected onInitialize(): void {
        this._spineData = this.resourcesLoader.loader.resources[this._options.key]?.spineData ?? null;

        // console.log(this._spineData);

        if (!this._spineData) {
            throw new Error(`Could not load spineData ${this._options.url}`);
        }

        this._spine = new PIXI.spine.Spine(this._spineData);
        this.display.addChild(this._spine);

        for (const index in this._options.animations) {
            this._spine.state.addAnimation(0, this._options.animations[index], false, 0);
        }

        this._spine.visible = false;
        this._spine.state.setEmptyAnimation(0, 0);
    }

    protected onDestroy() {
        if (this._spine) {
            this.resetAnimation();
            this.display.removeChild(this._spine);
            this._spine = null;
        }

        super.onDestroy();
    }

    public release(): void {
        if (this._spine) {
            this.resetAnimation();
            this.display.removeChild(this._spine);

            this._spine.destroy({ texture: true, baseTexture: true });
            this._spine = null;
        }
    }

    public setAnimation(key: string, loop: boolean): void {
        if (this._spine && this._spine.state) {
            if (this._spine.state.hasAnimation(key)) {
                if (this.currAnimation !== key) {
                    this._spine.visible = true;
                    this._spine.autoUpdate = true;
                    this._spine.state.timeScale = 1;
                    this.currentTrack = this._spine.state.setAnimation(0, key, loop);
                    this.currAnimation = key;
                }
            } else {
                this.resetAnimation()
            }
        } else {
            this.resetAnimation()
        }
    }

    public setAndStopAnimation(key: string): void {
        if (this._spine && this._spine.state) {
            if (this._spine.state.hasAnimation(key)) {
                if (this.currAnimation !== key) {
                    this._spine.visible = true;
                    this._spine.autoUpdate = true;
                    this._spine.state.timeScale = 0;
                    this.currentTrack = this._spine.state.setAnimation(0, key, false);
                    this.currAnimation = key;
                }
            } else {
                this.resetAnimation()
            }
        } else {
            this.resetAnimation()
        }
    }

    public resetAnimation(): void {
        console.log('reset');

        this.currAnimation = '';

        if (this._spine && this._spine.state) {
            this._spine.visible = false;
            this._spine.autoUpdate = false;
            this.currentTrack = this._spine.state.setEmptyAnimation(0, 0);
        }
    }

    public getSpine(): PIXI.spine.Spine {
        return this._spine;
    }

    public setAnimationPromise(key: string, loop: boolean): Promise<void> {
        if (this._spine.state.hasAnimation(key)) {
            return new Promise((resolve) => {
                this._spine.visible = true;
                // @ts-ignore
                this._spine.lastTime = 0;

                this.currentTrack = this._spine.state.setAnimation(this._options.animations.indexOf(key), key, loop);
                const listener = {
                    dispose: (track) => {
                        console.log(track, event);
                    },
                    complete: (track) => {
                        if (track === this.currentTrack) {
                            this._spine.state.removeListener(listener);
                            resolve();
                        }
                    },
                    event: (track, event) => {
                        console.log(track, event);
                    },
                };
                this._spine.state.addListener(listener);
            });
        } else {
            this._spine.visible = false;
            return Promise.resolve();
        }
    }

    public changeAnimationSpeed(timeScale) {
        if (this.currentTrack) {
            this.currentTrack.timeScale = timeScale;
        }
    }
}
